import { render, staticRenderFns } from "./Clients.vue?vue&type=template&id=92ad6e58&"
import script from "./Clients.vue?vue&type=script&lang=js&"
export * from "./Clients.vue?vue&type=script&lang=js&"
import style0 from "./Clients.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "../i18n/main.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fsrv%2Fphx%2Fatm%2Fv%2Fsrc%2Fviews%2FClients.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "../i18n/clients.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fsrv%2Fphx%2Fatm%2Fv%2Fsrc%2Fviews%2FClients.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports